import qs from 'qs';
import { call, put, takeLatest } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const FETCH_PRESCRIBERS_REGISTRY = 'FETCH_PRESCRIBERS_REGISTRY';
export const FETCH_PRESCRIBERS_REGISTRY_SUCCESS = 'FETCH_PRESCRIBERS_REGISTRY_SUCCESS';
export const FETCH_PRESCRIBERS_REGISTRY_FAIL = 'FETCH_PRESCRIBERS_REGISTRY_FAIL';
export const CLEAR_PRESCRIBERS_REGISTRY = 'CLEAR_PRESCRIBERS_REGISTRY';

// Reducer
export default function prescribersRegistryReducer(state = { data: [], loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_PRESCRIBERS_REGISTRY:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_PRESCRIBERS_REGISTRY_SUCCESS:
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_PRESCRIBERS_REGISTRY_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_PRESCRIBERS_REGISTRY:
      return {
        ...state,
        data: [],
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchPrescribersRegistry(payload) {
  return { type: FETCH_PRESCRIBERS_REGISTRY, payload };
}

export function fetchPrescribersRegistrySuccess(payload) {
  return { type: FETCH_PRESCRIBERS_REGISTRY_SUCCESS, payload };
}

export function fetchPrescribersRegistryFail(payload) {
  return { type: FETCH_PRESCRIBERS_REGISTRY_FAIL, payload };
}

export function clearPrescribersRegistry(payload) {
  return { type: CLEAR_PRESCRIBERS_REGISTRY, payload };
}

// Requests
export function requestFetchPrescribersRegistry(payload) {
  return callApi('resource/prescriber/get_prescriber_info/', 'POST', payload);
}

// Sagas
function* fetchPrescribersRegistrySaga(action) {
  const {
    triggerLoading,
    resolve,
    reject,
    values,
  } = action.payload;
  try {
    const res = yield call(requestFetchPrescribersRegistry, values);
    yield put(fetchPrescribersRegistrySuccess({
      data: res.data,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(fetchPrescribersRegistryFail({
      ...err.data,
      triggerLoading,
    }));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* prescribersRegistrySaga() {
  yield takeLatest(FETCH_PRESCRIBERS_REGISTRY, fetchPrescribersRegistrySaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/prescribersRegistry.js